import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import {
  CanActivate,
  CanActivateChild,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { CashierAssignmentCheckService } from './cashier-assignment-check.service';

@Injectable()
export class CashierAssignedGuard implements CanActivate, CanActivateChild {
  constructor(
    private _cashierAssignmentCheck: CashierAssignmentCheckService,
    private _location: Location,
    private _router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this._cashierAssignmentCheck.ensureAssignedOrWarn()) {
      return true;
    }

    // history.state.navigationId lo setea el Router de Angular en cada push de estado,
    // incrementando desde 1: > 1 indica que hubo una navegación previa dentro de la app
    // (y no, por ejemplo, que el usuario entró pegando la URL directamente).
    const navigationId = (this._location.getState() as { navigationId?: number })?.navigationId;
    if (navigationId != null && navigationId > 1) {
      this._location.back();
    } else {
      this._router.navigate(['/home']);
    }
    return false;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }
}
